import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_COURSE } from './constants';
import {
  loadCourseSuccess,
  loadCourseError,
} from './actions';

import requestUtil from 'utils/request';
import requestWrapper from 'utils/requestWrapper';
import _local from 'utils/localStorageUtils';

export function* loadCourse(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { id } = action;

    // we get the campaigns linked to the course
    const itemData = yield requestWrapper('GET', `courses/${id}`, '', currentUser.token);

    if (!id && !itemData) {
      yield put(loadCourseSuccess(false));
    } else {
      yield put(loadCourseSuccess(itemData));
    }
  } catch (error) {
    yield put(loadCourseError(error));
  }
}

// Individual exports for testing
export default function* coursesDetailSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_COURSE, loadCourse);
}
